import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import type { Get_CountriesQuery } from '../../apis/graphql';
import { GET_COUNTRIES } from './schemas/getCountries';

export type CountryNameMap = ReadonlyMap<string, string>;

export function useCountryNames(): { countryMap: CountryNameMap; loading: boolean } {
  const { data, loading } = useQuery<Get_CountriesQuery>(GET_COUNTRIES);

  const countryMap = useMemo((): CountryNameMap => {
    const map = new Map<string, string>();
    data?.getCountries?.forEach((c) => map.set(c.id, c.name));
    return map;
  }, [data]);

  return { countryMap, loading };
}

/** Converts country IDs to display names using the provided map; falls back to the raw ID. */
export function formatCountryIdsAsNames(ids: string[] | null | undefined, countryMap: CountryNameMap): string {
  if (!ids?.length) return '-';
  return ids
    .map((id) => countryMap.get(id) ?? id)
    .sort(new Intl.Collator().compare)
    .join(', ');
}
